import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import UniversalFormFIeld from "../../components/FormField";
import SubmitButton from "../../components/SubmitButton";
import useCategory from "../../hooks/useCategory";
import useNature from "../../hooks/useNature";
import FormField from "../companies/FormField";
import { Typography } from "@mui/material";
import { keys } from "../../config/keys";
import api from "../../app/api";
import { convertDateToDDMMYYYY, ddmmyyyy } from "../../config/functions";
import Loader from "../../components/Loader";
import EmptyData from "../../components/EmptyData";

const AddDocumentModal = ({
    showAddModal,
    docData,
    handleClose,
    modalName,
    selectedCategories,
    selectedNature,
    // docHistory
}) => {
    const onView = async (item) => {
        window.open(`${keys.BASE_URL}/management-system/download?filename=${item.url?.substring(8, item.url?.length)}`, "_blank");
    };
    const [docHistory, setDocHistory] = useState([])
    const [historyLoader, setHistoryLoader] = useState(false)
    const getHistory = async (msID) => {
        setHistoryLoader(true)
        try {
            const response = await api.get(
                "/management-system/getHistory",
                { params: { msID } }
            );
            if (response.data?.status) {
                setDocHistory(response.data?.result)
            } else {
                // showAlert(response.data.message, 'danger')
            }
        } catch (error) {

        }finally{
            setHistoryLoader(false)
        }
    };
    useEffect(() => {
        getHistory(docData._id)

    }, [docData])


    return (
        <>
            <Modal show={showAddModal} centered onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Typography variant="h6">File</Typography>
                    <div className="row g-3 align-items-center" style={{ margin: '0px 1px' }}>
                        {/* Input */}
                        <div className="col-9" style={{ border: '1px solid rgba(0,0,0,0.2)', padding: '6px 5px', borderRadius: '9px', marginTop: '0px' }}>
                            {docData.name}
                        </div>
                        {/* File Button */}
                        <div onClick={() => onView(docData)} className="col-3" style={{ marginTop: '0px' }}>
                            <label className="btn btn-success w-100" htmlFor="files">
                                Open
                            </label>
                        </div>

                    </div>
                    <br />
                    <Typography variant="h6">Categories</Typography>
                    <div className="row g-3 align-items-center" style={{ margin: '0px 1px' }}>
                        {selectedCategories.map((item, index) => (
                            <div className="col-12" key={index} style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: '6px 5px', borderRadius: '9px', marginTop: '0px', marginBottom: '4px' }}>
                                {item?.name}
                            </div>
                        ))}
                    </div>
                    <br />
                    <Typography variant="h6">Natures</Typography>
                    <div className="row g-3 align-items-center" style={{ margin: '0px 1px', paddingTop: '0px' }}>
                        {selectedNature.map((item, index) => (
                            <div className="col-12" key={index} style={{ backgroundColor: 'rgba(0,0,0,0.1)', padding: '6px 5px', borderRadius: '9px', marginTop: '0px', marginBottom: '4px' }}>
                                {item?.name}
                            </div>
                        ))}
                    </div>
                    <br />
                    <hr />
                    <Loader loading={historyLoader}>
                                <Typography variant="h6" sx={{ paddingBottom: '10px' }}>Document History</Typography>
                            <EmptyData data={docHistory}>
                            {docHistory?.map((item, index) => (
                                <div style={{ marginBottom: '20px' }}>
                                    <Typography><b>Updated at: </b>{convertDateToDDMMYYYY(item.createdAt)}</Typography>
                                    <div key={index} className="row g-3 align-items-center" style={{ margin: '0px 1px' }}>
                                        {/* Input */}
                                        <div className="col-9" style={{ border: '1px solid rgba(0,0,0,0.2)', padding: '6px 5px', borderRadius: '9px', marginTop: '0px' }}>
                                            {item?.name}
                                        </div>
                                        {/* File Button */}
                                        <div onClick={() => onView(item)} className="col-3" style={{ marginTop: '0px' }}>
                                            <label className="btn btn-success w-100" htmlFor="files">
                                                Open
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            </EmptyData>
                    </Loader>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddDocumentModal;
